var map = {
	"./badminton.png": 401,
	"./baseball.png": 402,
	"./basketball.png": 403,
	"./binary.png": 431,
	"./boxing.png": 404,
	"./cardicon.png": 405,
	"./casino.png": 406,
	"./crash_games.png": 432,
	"./cricket.png": 433,
	"./cs.png": 407,
	"./dota.png": 408,
	"./efighting.png": 409,
	"./election.png": 434,
	"./fifa.png": 410,
	"./formula.png": 411,
	"./golf.png": 412,
	"./greyhound-racing.png": 435,
	"./greyhound.png": 413,
	"./horse-racing.png": 436,
	"./horse.png": 414,
	"./inplay.png": 437,
	"./kabaddi.png": 415,
	"./live-card.png": 438,
	"./live-casino.png": 439,
	"./lottery.png": 440,
	"./more.png": 441,
	"./premium-notebook.png": 442,
	"./raceicon.png": 443,
	"./rugby.png": 416,
	"./slot-games.png": 444,
	"./sloticon.png": 417,
	"./sloticon1.png": 445,
	"./soccer.png": 446,
	"./sportsbook.png": 447,
	"./table-tennis.png": 418,
	"./tennis.png": 448,
	"./virtual.png": 419,
	"./voleyball.png": 420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 283;